const TOTAL_BARS = 8;
const BAR_COLORS = [
	'#2d50a7', // 0 degrees
	'#C4D9FD', // 45 degrees
	'#C4D9FD', // 90 degrees
	'#73A1FB', // 135 degrees
	'#5286FA', // 180 degrees
	'#3D6DEB', // 225 degrees
	'#355EC9', // 270 degrees
	'#2D50A7', // 315 degrees
];

interface PtrSpinnerProps {
	pullRatio?: number;
	spinning?: boolean;
	onRefresh?: () => void;
}

export default function PtrSpinner({ pullRatio = 0, spinning = false }: PtrSpinnerProps) {
	const bars = [];

	for (let i = 0; i < TOTAL_BARS; i++) {
		const angle = (360 / TOTAL_BARS) * i;
		const visibleBars = Math.floor(pullRatio * TOTAL_BARS);
		const isVisible = i < visibleBars;
		const barColor = BAR_COLORS[i];
		const barOpacity = isVisible ? 1 : 0;
		const transitionDelay = i * 50; 

		bars.push(
			<g key={i} transform={`rotate(${angle} 50 50)`}>
				<rect
					x='47.5'
					y='23'
					width='5'
					height='14'
					rx='2.5'
					ry='2.8000000000000003'
					className='transition-all duration-200 ease-out'
					style={{ 
						fill: barColor,
						opacity: barOpacity,
						transitionDelay: `${transitionDelay}ms`,
						transform: `scaleY(${isVisible ? 1 : 0.3})`,
						transformOrigin: 'center'
					}}
				/>
			</g>,
		);
	}

	return (
		<svg
			className={`transition-all duration-300 ease-out ${spinning ? 'animate-spin' : ''}`}
			viewBox='0 0 100 100'
			preserveAspectRatio='xMidYMid'
			width='60'
			height='60'
			style={{ 
				shapeRendering: 'auto', 
				display: 'block', 
				background: 'transparent'
			}}
		>
			<g>{bars}</g>
		</svg>
	);
}
